import {SecurityGateAlarmDto} from "./security-gate-alarm.dto";
import {DashboardAlertDto} from "./dashboard-alert.dto";
import {DeviceDto} from "./device.dto";
import {Serialisable} from "../serialisable";
import moment = require("moment");
import {DashboardOfflineImportFileDto} from "./dashboard-offline-import-file.dto";

export class DashboardDto extends Serialisable {
    totalInCount: number;
    totalOutCount: number;
    currentOccupancy: number;
    totalIssues: number;
    totalRenews: number;
    totalReturns: number;
    applicationVersion: String;
    alarms: SecurityGateAlarmDto[];
    alerts: DashboardAlertDto[];
    offlineImportFiles: DashboardOfflineImportFileDto[];
    sorters: DeviceDto[];

    public chartDataChanged(otherDashboard:DashboardDto) {
        return this.totalInCount != otherDashboard.totalInCount ||
            this.totalOutCount != otherDashboard.totalOutCount ||
            this.currentOccupancy != otherDashboard.currentOccupancy ||
            this.totalIssues != otherDashboard.totalIssues ||
            this.totalRenews != otherDashboard.totalRenews ||
            this.totalReturns != otherDashboard.totalReturns ||
            this.applicationVersion != otherDashboard.applicationVersion;
    }

    public fromObject(sourceObject: DashboardDto): DashboardDto {
        super.fromObject(sourceObject);

        this.alarms = [];
        for (let alarm of sourceObject.alarms) {
            alarm.dateTimeUtc = moment.utc(alarm.dateTimeUtc).local().format('h:mm a');
            this.alarms.push(new SecurityGateAlarmDto().fromObject(alarm));
        }

        this.alerts = [];
        for (let alert of sourceObject.alerts) {
            this.alerts.push(new DashboardAlertDto().fromObject(alert));
        }

        this.offlineImportFiles = [];
        for (let offlineImportFile of sourceObject.offlineImportFiles) {
            this.offlineImportFiles.push(new DashboardOfflineImportFileDto().fromObject(offlineImportFile));
        }

        this.sorters = [];
        for (let sorter of sourceObject.sorters) {
            this.sorters.push(new DeviceDto().fromObject(sorter));
        }

        return this;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/dashboard.dto.ts